import React, { useMemo, useEffect } from 'react';
import { buildSearchBox, buildStandaloneSearchBox, buildDidYouMean } from '@coveo/headless';
import SearchInput from './SearchInput';
import { buildEngine } from '../../engine/Engine';
import DidYouMean from '../../components/DidYouMean';

const CoveoSearchInput = props => {
  const {
    coveoOrganizationId,
    coveoAccessToken,
    coveoSearchHub,
    coveoPipeline,
    coveoRedirectUrl,
    coveoNumberOfSuggestions = 0,
    coveoEngine = null,
    searchInputPlaceholder = 'Search',
    searchShowIcon = null,
    searchShowDidYouMean = true,
    allowEmptyQueries = false,
    didYouMeanString = 'Did you mean',
    useButton = true,
  } = props;

  let engine;
  if (coveoEngine === null && coveoOrganizationId && coveoAccessToken) {
    engine = useMemo(() => {
      return buildEngine({
        organizationId: coveoOrganizationId,
        accessToken: coveoAccessToken,
        searchHub: coveoSearchHub,
        pipeline: coveoPipeline
      });
    }, []);
  } else if (coveoEngine !== null) {
    engine = useMemo(() => coveoEngine, [coveoEngine]);
  }

  let searchController;
  if (coveoRedirectUrl && coveoRedirectUrl !== '') {
    searchController = useMemo(
      () =>
        buildStandaloneSearchBox(engine, {
          options: {
            numberOfSuggestions: parseInt(coveoNumberOfSuggestions) || 0,
            redirectionUrl: coveoRedirectUrl
          }
        }),
      []
    );
  } else {
    searchController = useMemo(
      () =>
        buildSearchBox(engine, {
          options: {
            numberOfSuggestions: parseInt(coveoNumberOfSuggestions) || 0
          }
        }),
      []
    );
  }

  const didYouMeanController = buildDidYouMean(engine);

  const handleCorrectionClick = correction => {
    searchController.updateText(correction);
    searchController.submit();
  };

  return (
    <>
      <div className="coveo-search-input-headless">
        <SearchInput
          controller={searchController}
          placeholder={searchInputPlaceholder}
          useButton={useButton}
          showIcon={
            (searchShowIcon && searchShowIcon !== 'false') ||
            searchShowIcon === 'true'
          }
          allowEmptyQueries={allowEmptyQueries}
        />
        {((searchShowDidYouMean && searchShowDidYouMean !== 'false') ||
          searchShowDidYouMean === 'true') && (
          <DidYouMean
            didYouMeanString={didYouMeanString}
            controller={didYouMeanController}
            onCorrectionClick={handleCorrectionClick}
          />
        )}
      </div>
    </>
  );
};

export default CoveoSearchInput;
